module.exports = __webpack_public_path__ + "media/flags/iq-6c440f16.svg";